var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-edit-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.75 6.06775L15.25 7.56775V4H8.50002V7.75H4.75002V16H15.25V13.9323L16.75 12.4323V16.756C16.7498 16.9534 16.6713 17.1426 16.5316 17.2821C16.392 17.4216 16.2027 17.5 16.0053 17.5H3.99477C3.89628 17.4993 3.79888 17.4792 3.70815 17.4409C3.61742 17.4026 3.53513 17.3468 3.46597 17.2766C3.39681 17.2065 3.34215 17.1234 3.30509 17.0322C3.26804 16.9409 3.24933 16.8432 3.25002 16.7448V7L7.75227 2.5H15.9985C16.4125 2.5 16.75 2.84125 16.75 3.244V6.06775ZM17.3335 7.60525L18.394 8.6665L12.5605 14.5L11.4985 14.4985L11.5 13.4395L17.3335 7.606V7.60525Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.8efcfdf193a44bce4bbec25b23c851c3.svg";
export { ForwardRef as ReactComponent };